import * as React from 'react';
import {useState} from "react";
// import ItemCard from "./ItemCard";

import {useInventory} from "../../context/InventoryContext";
import useToggle from "../../shared/functions/useToggle";

import {Avatar, Stack, Typography, Chip} from "@mui/material";

import AntDataGrid from "../../shared/components/AntDataGrid";
// import AntDataGridDeux from "../../shared/components/AntDataGridDeux";
import InventoryDataGridToolbar from "./InventoryDataGridToolbar";
import InventoryOrdered from "./InventoryOrdered";
import InventoryForcasted from "./InventoryForcasted";
import InventoryDetails from "./InventoryDetails";
import NewQtyToBuy from "../PurchaseCart/fragments/dataGrid/NewQtyToBuy";
import {makeStyles} from "@material-ui/core/styles";

import {getInventory, getItemInventory} from 'src/redux/slices/inventory/inventory.thunks'
import {useDispatch} from "react-redux";


const useStyles = makeStyles((theme) => ({
    container: {
        width: 400,
        margin: 10,
        cursor: "pointer"
    },
    avatar: {
        height: 400,
        width: 400
    },
    detailDiv: {
        marginLeft: 10
    },
    detailElement: {
        margin: 5,
        width: 200,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "clip",
    }
}))

const columns = [
    {
        title: 'Image', dataIndex: 'ImageUrl', key: 'ProductImageUrl',
        render: (image) => {
            return (
                <>
                    {
                        image
                            ? <Avatar alt={'...'} src={image}/>
                            : <Avatar>no</Avatar>
                    }
                </>
            )
        }
    },

    {
        title: 'Name', dataIndex: 'Name', key: 'Name',
        render: (val, {IsParent, HasChilds}) => {

            const ft = text => (text || '')?.trim()?.toLowerCase()

            const list = ['pack', ' pac ', ' pak ', ' pk '];

            let flag = ((IsParent || [])?.length > 0) || (HasChilds) || false

            list.forEach(label => {
                if (ft(val)?.includes(label))
                    flag = true
            })

            return (
                <Stack direction={'row'} spacing={1}>
                    <Typography>
                        {val}
                    </Typography>

                    {flag && (<Chip color={'success'} label={'Pk'}/>)}

                </Stack>
            )
        }
    },

    // {
    //     title: 'Seuil', dataIndex: 'Threshold', key: 'Threshold',
    //     render: (Threshold) => {
    //         return Threshold || 0
    //     }
    // }, <AddQuantity show={isCreateModalQuantityOpen}  itemData={selectedItem} onClose={handleCreateQuantityModalClosing}/>
  /*  {
        title: 'Qt. by month', dataIndex: '_', key: 'Stock',
        render: (_, record) => (
            <NewQtyForMonth {...record}/>
        )
    },*/

        {
            title: 'Month Qt.', dataIndex: '_', key: 'Stock',
            render: (_, {QuatityForMonth}) => QuatityForMonth ?? 0
        },

    {
        title: 'Qt. available', dataIndex: '_', key: 'Stock',

        render: (_, record) => (

            <InventoryForcasted {...record} />
        )
    },
    /*
        {
            title: 'Qt. forcasted', dataIndex: '_', key: 'Stock',
            render: (_, record) => (
                <InventoryOrdered {...record} />
            )
        },*/

    {
        title: 'Qt. to purchase', dataIndex: '_', key: 'Stock',
        render: (_, {QuantityToBuy}) => QuantityToBuy
    },

    {
        title: 'Qt. left to buy', dataIndex: '_', key: 'Stock',
        // render: (_, {RestQtyToBuy}) => RestQtyToBuy
        render: (_, RestQtyToBuy) => (
            <NewQtyToBuy {...RestQtyToBuy}             
            />
        )
    },

    // {
    //     title: 'Product Status', dataIndex: 'NotImportantToPurchase', key: 'Stock',
    //     render: (_, record) => (
    //         <ProductStatus {...record}  />
    //     )
    //     render: (NotImportantToPurchase, record) => (
    //         <span>
    //           {NotImportantToPurchase.map(NotImportantToPurchase => {
    //             let color = NotImportantToPurchase.length > 4 ? 'geekblue' : 'green';
    //             if (NotImportantToPurchase === 'false') {
    //               color = 'red';
    //             }
    //             return (
    //                 <ProductStatus {...record} />
    //             );
    //           })}
    //         </span>
    //       ),
    // },

];

const FILTER_INITIAL_STATE = {
    date: {start: null, end: null},
    delivery: {vendor: null}
};


export default function InventoryDataGrid() {
    const {data, loading, loadMore ,aaa} = useInventory();
    //const [listcard,setListCard]= useState('card');

    
    // console.log(data[0])
    const classes = useStyles();

    //localStorage.setItem('ComposeFilter', JSON.stringify(FILTER_INITIAL_STATE));

    const handleSelection = record => {
        //console.log("kkKK"+JSON.stringify(record))
        setSelected(record)
        handleOpen();
    }
    const handleOneSelection = record => {
        //console.log("kkKK"+JSON.stringify(record))
        setSelected(record)
        handleOpen();
    }

    const handleDetailModalClosing = () => {
        setSelected(null)
        handleClose()
    }

    const handlePageChange = (current, total) => (current === (total - 1) || current === total) && loadMore()
    const handleFilterModalShowing = () => {
        setIsFilterModalShown(true)
    }
    // const handleTableShowing = (etat) =>{
    //     if(etat=='card'){
    //         setListCard('card');
    //     }
    //     else{
    //         setListCard('list');
    //     }
    // }

    
 
    const dispatch = useDispatch();
    const [selected, setSelected] = useState(null)
    const [my_vendor_id, setMyVendorId] = useState("")
    const {open, handleClose, handleOpen} = useToggle()
    const {open: isCreateModalOpen, handleClose: handleOrderClose, handleOpen: handleOrderOpen} = useToggle()
    const {open: isCreateCartModalOpen, handleClose: handleCartClose, handleOpen: handleCartOpen} = useToggle()
    const {open: isCreateModalQuantityOpen, handleClose: handleQuantityClose, handleOpen: handleQuantityOpen} = useToggle()
    const {hide, filters, addToCartForFutureOder} = useInventory();
    const [selectedDate, handleDateChange] = useState(new Date());
    const [isFilterModalShown, setIsFilterModalShown] = useState(false); 

    const handleDate2Change = (value) => {
        handleDateChange(value) 
        var month = value.getMonth()+1
        var filterbyData = value.getDate()+"-"+month+"-"+value.getFullYear()

        var date = new Date(filterbyData)

        var goodDAte = month +"-"+value.getDate()+"-"+value.getFullYear() 

        dispatch(getInventory(null, false, 100, null, new Date(goodDAte)))
    }
    const handleFilterModalClosing = () => {
        setIsFilterModalShown(false)
    };

    const handleFilterChange = (filter) => {
        dispatch(getInventory(filters, false, 100, null,  ""))
    }
    
    return (
        <>
        {
               
                <AntDataGrid
                data={data}
                columns={columns}
                isLoading={loading}
                ToolBar={InventoryDataGridToolbar}
                onPageChange={handlePageChange}
                doubleClickAction={handleSelection}
                shadows
            />
            }

            
           {
                selected && (
                    <InventoryDetails
                        open={open}
                        item={selected}
                        onClose={handleDetailModalClosing}
                    />
                )
            }
            
        </>
    )

}